import React from "react";
import ReactDOM from "react-dom";
import { Router } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import history from "./modules/history";
import "normalize.css";

import "./styles/index.css";
import AppRoutes from "./routes";

import theme from "./theme/default";

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <Router history={history}>
      <AppRoutes />
    </Router>
  </ThemeProvider>
  , document.getElementById("root")
);
